<template>
  <v-dialog v-model="show" :max-width="680">
    <v-card tile rounded="false" class="popup_wrap">
      <v-toolbar flat height="54">
        <v-toolbar-title>최근 구강촬영 결과</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="result">
        <div class="wrapper">
          <div class="text_box">
            <table>
              <tr>
                <th>촬영일시</th>
                <th>이름</th>
                <th>연락처</th>
              </tr>
              <tr>
                <td>{{ !!data.latestDate ? $convertDateFormat('YYYYMMDDDayTimeKR', data.latestDate) : '-' }}</td>
                <td>{{ data.name }}</td>
                <td>{{ !!data.phoneNumber ? $convertTelFormat(data.phoneNumber) : '-' }}</td>
              </tr>
            </table>
            <img v-if="!error" :src="data.photo" alt="구강촬영 사진" @error="errorCheck()" />
            <p class="status">
              {{ data.name }}님의 잇몸상태는
              <strong :class="data.resultType">{{ resultType(data.resultType) }}</strong>입니다.
            </p>
            <dl>
              <dt>이상개수</dt>
              <dd>상악: {{ data.upPercent }}개</dd>
              <dd>하악: {{ data.downPercent }}개</dd>
            </dl>
            <p class="comment">
              <strong>{{ data.resultComment.split('\n')[0] }}</strong>
              <span>{{ data.resultComment.split('\n')[1] }}</span>
            </p>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserResultPopup',
  props: {
    // id: Number,
    data: {
      type: Object,
      default: {
        latestDate: '',
        name: '',
        phoneNumber: '',
        photo: '',
        resultType: '',
        upPercent: 0,
        downPercent: 0,
        resultComment: '',
      },
    },
    value: Boolean,
  },
  data: () => ({
    error: false,
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    resultType(type) {
      switch (type) {
        case 'S':
          return '정상';
        case 'G':
          return '주의';
        case 'A':
          return '약간위험';
        case 'D':
          return '위험';
        default:
          return '-';
      }
    },
  },
  errorCheck() {
    this.error = true;
    this.$emit('error');
  },
}
</script>

<style scoped>
.wrapper {
  padding: 32px 40px;
  color: #2a2a2a;
}
table {
  table-layout: fixed;
  width: 100%;
  border-spacing: 0;
}
th,
td {
  text-align: center;
  border: 1px solid #d7dae0;
}
th + th,
td + td {
  border-left: none;
}
th {
  height: 32px;
  background-color: #d7dae0;
  font-size: 12px;
}
td {
  height: 36px;
}
img {
  width: 100%;
  margin-top: 24px;
}
.status {
  margin-top: 40px;
  line-height: 28px;
  font-size: 20px;
  font-weight: 700;
}
.status .S {
  color: #337eff;
}
.status .G {
  color: #27c4aa;
}
.status .A {
  color: #fcb519;
}
.status .D {
  color: #e64e81;
}
dl {
  display: flex;
  margin-top: 16px;
  line-height: 26px;
  font-size: 18px;
  font-weight: 700;
}
dt {
  position: relative;
  padding-right: 34px;
}
dt::after {
  content: '';
  position: absolute;
  top: calc(50% - 8px);
  right: 16px;
  width: 2px;
  height: 16px;
  background-color: #767a83;
}
dd + dd {
  margin-left: 24px;
}
.comment {
  margin-top: 16px;
  line-height: 22px;
  font-size: 16px;
}
.comment span {
  display: block;
  margin-top: 8px;
  color: #4a4a4a;
}
</style>
